import React, { Component } from "react";

import '../App.css';

// import { AppBar, Toolbar, IconButton, Tooltip, } from "@material-ui/core";

import AppBar from '@material-ui/core/AppBar';

import Toolbar from '@material-ui/core/Toolbar';

import IconButton from '@material-ui/core/IconButton';

import { Tooltip, Card, Divider } from '@material-ui/core';


import { loggingout, FetchUser } from '../services/userServices';

import AccountCircle from '@material-ui/icons/AccountCircle';



import Typography from '@material-ui/core/Typography';

import MenuIcon from '@material-ui/core/Menu'

import { PropTypes } from "prop-types";

import { withStyles } from '@material-ui/core/styles'


import Drawer from '../components/Drawer.jsx'

import MenuItem from '@material-ui/core/MenuItem';

import Menu from '@material-ui/core/Menu';

import Button from '@material-ui/core/Button'

import {
    Input,

} from "@material-ui/core";


const styles = theme => ({
    root: {
        width: '100%'
    },

    appBar: {
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
            position: 'fixed',


        })
    },

    menuButton: {
        // backgroundColor: "black",
        backgroundColor: '#422963',
        marginLeft: 10,
        marginRight: 5
    },

    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: "47px",
        marginLeft: "5%",
        marginTop: "3px",
        transition: theme.transitions.create("width"),
        width: "100%"
    },

    brandLogo: {
        //   width: 10,
        //   height: 10,
          // objectFit:"cover",
          objectFit:'cover',
        width: 50,
        height: 50
      },

});



class TopBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            name: "ChromaFan",
            userData: {},


            // auth: true,
            // setAuth: true,

            anchorEl: null,
            // setAnchorEl: null,


            firstName: '',
            lastName: '',
            email: '',
            phone: ''


        }

    }

    /********************************************************************************************************************************* */

    handleAppbar = () => {
        this.props.notePropsToApp()
    }

    handleToggle = event => {
        this.props.slideCards();
        this.setState({
            open: true
        });
    }
    copy(mainObj) {
        let objCopy = {}; // objCopy will store a copy of the mainObj
        let key;

        for (key in mainObj) {
            objCopy[key] = mainObj[key]; // copies each property to the objCopy object
        }
        return objCopy;
    }
    handleClose = event => {
        this.setState({
            name: event
        });
    }
    /************************************************************************************************************************************ */
    LogMeOut() {

        //  loggingout()
        // .then((response) => {
        //     console.log(response)
        // })
        sessionStorage.clear();



        loggingout()
            .then(() => {
                setTimeout(() => {
                    window.location.href = "/login"
                }, 200);
            })
    }

    /****************************************************************************************************************************** */








    /************************************************************************************************************************************ */
    handleMenu = event => {
        FetchUser()
            .then((response) => {
                // console.log("response", response);
                this.setState({
                    firstName: response[0].firstName,
                    lastName: response[0].lastName,
                    email: response[0].email,
                    phone: response[0].phone
                });

            })
            .catch((error) => {
                console.log(error);
            });
        this.setState({
            anchorEl: event.currentTarget
        })
    }


    handleClosed = event => {
        this.setState({
            anchorEl: null
        })
    }




    // let openEl = Boolean(anchorEl);

    /********************************************************************************************************************** */



    render() {

        const { classes } = this.props;

        const { anchorEl } = this.state


        return (
            <div className={classes.root}>

                <div>

                    <AppBar
                        position="fixed"
                        className={classes.appBar}
                        // color='default'
                        // backgroundColor="blue"
                        id='AppBar'
                    >

                        <Toolbar style={{ paddingRight: 2 ,  backgroundColor: '#422963'}}>
                            {/* <IconButton
                                className={classes.menuButton}
                                // id="Button"
                                style={{ backgroundColor: 'white' ,outline:'none' }}
                                onClick={this.handleToggle}>

                                <Tooltip title="Main Menu">
                                <MenuIcon />
                                </Tooltip>
                                
                            { <img
                               src={require('../assets/menu-white.svg')}
                               alt="menu" 
                            /> }
                            </IconButton> */}

                            <Typography variant="h4" noWrap style={{ width: 'calc(100% - 44px)' }} >
                                ChromaFan
                                <img
                                src={require('../assets/Logo_Image.png')}
                                alt='BrandLogo'
                                className={classes.brandLogo}        
                                 />
                            </Typography>

                            
                           
                            


                            {/* <button  onClick={this.LogMeOut} >Logout</button> */}
                            {/* <AccountCircle
                                
                                className="AccCircle"
                             onClick={this.LogMeOut} /> */}


                            <div>
                                <IconButton
                                    aria-label="Account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    style={{ outline: 'none' }}
                                    onClick={this.handleMenu}
                                    color="inherit"
                                >
                                    <AccountCircle />
                                </IconButton>

                                <div className="SetmyWidth">
                                    <Menu
                                        className='MenuPopup'
                                        id="menu-appbar"
                                        anchorEl={anchorEl}
                                        anchorOrigin={{
                                            width:'100%',
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorEl)}
                                        onClose={this.handleClosed}
                                    >

                                        <div style={{width:'100%'}}>
                                            {/* <div className="AccDetails" >  */}
                                            {/* <div className="AccDetails1" > */}

                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} >


                                                <section class="sectionClass" style={{ padding: '0 20px', width: '100%' }} >
                                                        <div class="row">

                                                            <div className="col-md-2 col-sm-6 p-0" >
                                                                <div className='labelDivLeft' >
                                                                    <img
                                                                        src={require('../assets/account_circle.svg')}
                                                                        alt='CompanyIcon'
                                                                        id="NavButton" />
                                                                </div>

                                                                <div className='labelDivLeft'>
                                                                    <img
                                                                        src={require('../assets/email.svg')}
                                                                        alt='CompanyIcon'
                                                                        id="NavButton" />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-10 col-sm-6 p-0">
                                                                <div className='labelDivLeft'   >
                                                                    <label>{this.state.firstName + ' ' + this.state.lastName} </label>
                                                                </div>

                                                                <div className='labelDivLeft' >
                                                                    <label>{this.state.email}</label>
                                                                </div>
                                                            </div>

                                                        </div>
                                                </section>

                                            </div>

                                            {/* </div> */}
                                            {/* </div> */}

                                            <Divider />
                                            <div className="Logout" >
                                                <div className="Logout2"  >
                                                    <MenuItem style={{ fontWeight: 'bold' }} onClick={this.LogMeOut}>Logout</MenuItem>
                                                    {/* <Button type="submit" id="button12Logout" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} title="Click to Logout" onClick={this.LogMeOut}  >
                                                        Logout</Button> */}
                                                </div>
                                            </div>
                                        </div>

                                    </Menu>
                                </div>

                            </div>


                        </Toolbar>

                    </AppBar>

                </div>

                <Drawer
                    AppBarProps={this.state.open}
                    drawerClose={this.handleClose}
                    handleNavigation={this.props.handleNavigation}
                />

            </div>


        )
    }
}

TopBar.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TopBar);













//      {/* <MenuItem style={{fontWeight:'bold'}} onClick={this.handleClosed}> Profile </MenuItem> */}
//      <div>
//      <h5 style={{textDecorationLine:'underline'}}>Admin Information</h5>
//      <div style={{ display: 'flex', flexDirection: 'column' ,margin:'20px' }} >
//          <label> Admin Name </label>
//          <label> Admin Email-Id </label>
//      </div>
//  </div>

// <Divider/>

//  <MenuItem style={{ fontWeight: 'bold' }} onClick={this.LogMeOut}>Logout</MenuItem>
//  {/* <MenuItem onClick={this.handleClosed}>My account</MenuItem> */}











// {/* <label> {this.state.firstName} </label> */}
//                                                     {/* <label> {this.state.email} </label> */}
//                                                     {/* <label> {this.state.phone} </label> */}



//                                                     <MenuItem
//                                                         // className={classes.menuItem}
//                                                         // id="sideMenu"
//                                                         // selected={this.state.companiesSelect}
//                                                         // onClick={() => this.handleCompanies('Companies')}  
//                                                         >

//                                                          <img
//                                                         src={require('../assets/account_circle.svg')}
//                                                         alt='CompanyIcon'
//                                                         id="NavButton" />  

//                                                         {/* <div className="sampl">Settings</div> */}
//                                                          <label> {this.state.firstName + " " + this.state.lastName } </label>

//                                                     </MenuItem>



//                                                     <MenuItem
//                                                         // className={classes.menuItem}
//                                                         // id="sideMenu"
//                                                         // selected={this.state.companiesSelect}
//                                                         // onClick={() => this.handleCompanies('Companies')}  
//                                                         >

//                                                          <img
//                                                         src={require('../assets/email.svg')}
//                                                         alt='CompanyIcon'
//                                                         id="NavButton" />  

//                                                         {/* <div className="sampl">Settings</div> */}
//                                                          <label> {this.state.email} </label>

//                                                     </MenuItem>





//           {/* <Divider /> */}

//                                         {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
//                                             <div className="Logout" > */}

//                                         {/* <div className="Logout1" >
//                                                     <a className="AddAcc" href='/reg' > Add Account</a>
//                                                 </div> */}

//                                         {/* <div className="Logout2"> */}
//                                         {/* <a className='LogUser' href='/login'> Logout </a> */}
//                                         {/* </div> */}

//                                         {/* </div>
//                                         </div> */}
// {/* 
//                                           <MenuItem style={{ fontWeight: 'bold' }} onClick={this.LogMeOut}>Logout</MenuItem>
//                                         <div style={{textAlign:'center'}} >
//                                             <Button type="submit" id="button12" title="Sign-up">
//                                                 Sign In</Button>
//                                         </div> */}